import "../sass/main.scss";

import "./lib/iop-browser-environment.mjs";
import "./lib/iop-scroll-depth.mjs";

import "./polyfills/custom-event.js"; // TODO: This can't possibly still be needed...

/**
 * remove body.no-js and add body.js (formerly done by Modernizr)
 */
document.documentElement.classList.remove("no-js");
document.documentElement.classList.add("js");

import $ from "jquery";
$(async () => {
  window.jQuery = $;
  window.$ = $;

  console.log("jQuery loaded, importing Sticky-kit");
  await import("./lib/jquery.sticky-kit.js");
  await import("./modules/sticky-sidebar.js");
  console.log("sticky-kit loaded");
});

// moved into async jQuery import
// import "./lib/jquery.sticky-kit.min.js";
import "./lib/event-tracking.js";

import "./modules/global.js";
import "./modules/menu.js";
import "./modules/menu-searchform.js";
import "./modules/share.js";
import "./modules/accordion.js";

// moved into async jQuery import
// import "./modules/sticky-sidebar.js";

import "./modules/filter-toggle.js";
import "./modules/subscribe.js";
import "./modules/subscribe-submit.js";
import "./modules/aos-animation.js";
import "./modules/prevent-resizing-transitions.js";

import "./components/grid-filters/grid-filters.jsx";


/**
 * Make cards clickable
 */
import {cardLinker} from "./modules/card-linker.js"
cardLinker('.card--person');


// Temporary Modules
// import "../modules/iop20/js/iop20.js";

import {rolloverHandler}  from "../../lib/Block/Variation/FeaturedImageRollover/featured-image-rollover.js"
rolloverHandler();
